import kebabCase from 'lodash/kebabCase';
import { ShopNavigationOptions } from '@data/shops';

export const addShopDataToContentBlocks = ({
  contentBlocks,
  chimeId,
  chimeType,
  contentfulTagIds,
  shopIds,
  pageData,
  shopname,
  shopNavigationOptions,
  googleSearchCountryCodeList,
  hideRentFilters,
  locale,
}: {
  contentBlocks?: any[];
  chimeId?: string;
  chimeType?: string;
  contentfulTagIds?: string | null;
  shopIds?: string;
  pageData?: any;
  shopname?: string;
  shopNavigationOptions?: ShopNavigationOptions;
  googleSearchCountryCodeList?: string[];
  hideRentFilters?: boolean;
  locale?: string;
}): any[] => {
  let updatedContentBlocks;
  if (contentBlocks && contentBlocks?.length > 0) {
    updatedContentBlocks = contentBlocks
      .map((block: any) => {
        // Skip if block doesn't have a "fields" field
        if (!block.fields) return null;
        //add chime data to all necessary blocks
        if (
          (block?.sys?.contentType?.sys?.id === 'StackedTextImageForm' ||
            block?.sys?.contentType?.sys?.id === 'contactForm' ||
            block?.sys?.contentType?.sys?.id === 'newsletterForm' ||
            block?.sys?.contentType?.sys?.id === 'leadGenerationForm') &&
          chimeId &&
          chimeType
        ) {
          block = {
            ...block,
            fields: {
              ...block.fields,
              chimeId: chimeId,
              chimeType: chimeType,
              shopname,
            },
          };
        }
        //add contentful ids data to all necessary blocks
        if (
          (block?.sys?.contentType?.sys?.id === 'blogHomepageFeaturedArticles' ||
            block?.sys?.contentType?.sys?.id === 'americasBlogHomepageFeaturedArticles') &&
          contentfulTagIds
        ) {
          block = {
            ...block,
            fields: {
              ...block.fields,
              contentfulTagIds,
              shopname,
            },
          };
        }
        if (
          block?.sys?.contentType?.sys?.id === 'newestListingsSection' ||
          block?.sys?.contentType?.sys?.id === 'localShopsSection'
        ) {
          block = {
            ...block,
            fields: {
              ...block.fields,
              shopIds,
            },
          };
        }
        if (block?.sys?.contentType?.sys?.id === 'blogSection') {
          block = {
            ...block,
            fields: {
              ...block.fields,
              contentfulTagIds,
              pageData,
              shopname,
            },
          };
        }
        if (block?.sys?.contentType?.sys?.id === 'featuredNeighborhoodsSection') {
          block = {
            ...block,
            fields: {
              ...block.fields,
              isShopOrShopGroupPage: true,
            },
          };
        }
        if (
          [
            'WideStackedTextImageBlock',
            'contactForm',
            'wideTextImage',
            'StackedTextImageForm',
          ].includes(block?.sys?.contentType?.sys?.id)
        ) {
          block = {
            ...block,
            className: block?.sys?.contentType?.sys?.id
              ? `${kebabCase(block?.sys?.contentType?.sys?.id)}-cn`
              : null,
          };
        }
        if (block?.sys?.contentType?.sys?.id === 'searchHero') {
          block = {
            ...block,
            fields: {
              ...block.fields,
              pageData,
              googleSearchCountryCodeList,
              shopNavigationOptions,
              hideRentFilters,
              locale,
            },
          };
        }
        return block;
      })
      .filter(Boolean);
  }
  return updatedContentBlocks;
};
